import styled from "styled-components";

import { BaseBoxBody } from "@src/modules/DeviceStatus/Devices/DeviceInfoView/ResultsView/ResultsView.components";
import { DicomImages } from "@src/modules/shared/components/Results/Results.components";

export const ImagesBoxBody = styled(BaseBoxBody)`
  border-top: 1px solid #d5e2ea;
`;

export const StyledDicomImages = styled(DicomImages)`
  margin-top: 0;
`;
